import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        padding: '20px 40px',
        marginTop: '30px',
        boxShadow:
            '0 0 0 1px rgb(63 63 68 / 5%), 0 9px 22px 0 rgb(51 46 49 / 15%)',

        '& ul': {
            margin: 0,
            marginLeft: '30px',
            listStyle: 'none',
            '& li': {
                fontSize: '16px',
                lineHeight: '32px',
                color: theme.palette.black,
                fontWeight: 'normal',
            },

            [theme.breakpoints.down('md')]: {
                marginLeft: 0,

                '& li': {
                    fontSize: '14px',
                },
            },
        },

        [theme.breakpoints.down('md')]: {
            padding: '20px',
            paddingLeft: 0,

            '& ul': {
                padding: 0,
                paddingLeft: '34px',

                '& li': {
                    fontSize: '14px',
                },
            },
        },
    },
    image: {
        [theme.breakpoints.down('md')]: {
            width: 0,
        },
    },
    row: {
        '&::before': {
            content: '"\\2022"',
            color: '#ababab',
            fontWeight: 'bold',
            display: 'inline-block',
            width: '1em',
            marginLeft: '-1em',
        },

        [theme.breakpoints.down('md')]: {
            lineHeight: '1.5rem',
            paddingBottom: 8,
        },

        '& svg': {
            // marginLeft: '6px',
            width: 25,
            height: 25,
            verticalAlign: 'middle',
        },
    },
    reloadLink: {
        textTransform: 'lowercase',
        fontStyle: 'italic',
        fontSize: 18,
        margin: '0px 5px',
        cursor: 'pointer',
    },
}));
